import React from "react";
import classNames from "classnames";
import { Identifiable, Role } from "@planzone/dto";
import { useEditResource, useRolesRetrieval } from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { SelectedIcon } from "@common/selectedIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function RoleSelection(props: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();
  const { editResource } = useEditResource(props.resource);
  const isSelectedRole = (role: Identifiable<Role>) =>
    role.name.slice(0, "pz_".length) === "pz_";
  const editResourceRole = (role: Identifiable<Role>) =>
    editResource({
      resource: props.resource,
      nextResource: { ...props.resource, role },
    });

  return props.readOnly ? (
    <div
      className={classNames(styles.input, styles.readOnly, {
        [styles.compact]: props.isCompact,
      })}
    >
      {props.resource.role ? (
        <p>
          {t(`roles.${props.resource.role.name}`, props.resource.role.name)}
        </p>
      ) : (
        <p className={styles.textHidden}>e</p>
      )}
    </div>
  ) : (
    <SelectList
      rootClassName={styles.roleSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select }) => ({
        input: (
          <div
            className={classNames(styles.input, {
              [styles.openedInput]: isOpen,
              [styles.compact]: props.isCompact,
            })}
          >
            {props.resource.role ? (
              <p>
                {t(
                  `roles.${props.resource.role.name}`,
                  props.resource.role.name,
                )}
              </p>
            ) : (
              <p className={styles.textHidden}>e</p>
            )}
            {isOpen ? (
              <div>
                <ArrowIcon className={styles.iconOpen} />
              </div>
            ) : (
              <ArrowIcon className={styles.iconClose} />
            )}
          </div>
        ),
        list: (
          <div className={styles.list}>
            {roles.filter(isSelectedRole).map((role, key) => (
              <div
                className={styles.role}
                key={key}
                onClick={() => select(editResourceRole(role))}
              >
                {props.resource.role &&
                props.resource.role.name === role.name ? (
                  <div className={styles.selectedRole}>
                    <div className={styles.selectedRoleTitle}>
                      {t(`roles.${role.name}`, role.name)}{" "}
                      <SelectedIcon className={styles.selectedRoleIcon} />
                    </div>
                  </div>
                ) : (
                  <div>{t(`roles.${role.name}`, role.name)}</div>
                )}
                <div className={styles.roleDescription}>
                  {t(`roles.description.${role.name}`, role.name)}
                </div>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { RoleSelection };
